import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X, Heart, ShoppingBag, Trash2 } from 'lucide-react';
import { useFavorites } from '../context/FavoritesContext';
import { useCart } from '../context/CartContext';
import './FavoritesDrawer.css';

const FavoritesDrawer = () => {
    const { favorites, toggleFavorite, isFavoritesOpen, setIsFavoritesOpen } = useFavorites();
    const { addToCart, setIsCartOpen } = useCart();

    const handleMoveToCart = (item) => {
        addToCart(item);
        // Optional: remove from favorites after adding to cart? User request didn't specify.
        // Usually better to keep as favorite and just add to cart.
    };

    return (
        <AnimatePresence>
            {isFavoritesOpen && (
                <>
                    <motion.div
                        className="drawer-overlay"
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        exit={{ opacity: 0 }}
                        onClick={() => setIsFavoritesOpen(false)}
                    />
                    <motion.div
                        className="favorites-drawer"
                        initial={{ x: '100%' }}
                        animate={{ x: 0 }}
                        exit={{ x: '100%' }}
                        transition={{ type: 'spring', damping: 25, stiffness: 200 }}
                    >
                        <div className="drawer-header">
                            <div className="flex items-center gap-3">
                                <div className="header-icon-box fav">
                                    <Heart size={20} fill="currentColor" />
                                </div>
                                <h2 className="text-2xl font-black italic">Mes Favoris</h2>
                            </div>
                            <button className="close-drawer" onClick={() => setIsFavoritesOpen(false)}>
                                <X size={24} />
                            </button>
                        </div>

                        <div className="drawer-content">
                            {favorites.length === 0 ? (
                                <div className="empty-drawer">
                                    <div className="empty-icon">❤️</div>
                                    <h3>Aucun favori pour le moment</h3>
                                    <p>Ajoutez vos plats préférés pour les retrouver facilement.</p>
                                    <button
                                        className="continue-btn"
                                        onClick={() => setIsFavoritesOpen(false)}
                                    >
                                        Parcourir la carte
                                    </button>
                                </div>
                            ) : (
                                <div className="fav-items-list">
                                    {favorites.map((item) => (
                                        <motion.div
                                            key={item.id}
                                            className="fav-item-card"
                                            layout
                                        >
                                            <div className="fav-item-info">
                                                <h4 className="font-bold">{item.name}</h4>
                                                <p className="text-xs text-gray-400">{item.price}€</p>
                                            </div>
                                            <div className="fav-item-actions">
                                                <button
                                                    className="add-to-cart-small"
                                                    onClick={() => handleMoveToCart(item)}
                                                >
                                                    <ShoppingBag size={16} />
                                                </button>
                                                <button
                                                    className="remove-fav-btn"
                                                    onClick={() => toggleFavorite(item)}
                                                >
                                                    <Trash2 size={16} />
                                                </button>
                                            </div>
                                        </motion.div>
                                    ))}
                                </div>
                            )}
                        </div>
                    </motion.div>
                </>
            )}
        </AnimatePresence>
    );
};

export default FavoritesDrawer;
